import { connect } from "react-redux";
import ManagePMSlot from "./managePMSlot";
import { bindActionCreators } from "redux";
import {fetchPmAssignee,postSchedulePM,fetchPmSlotDetails} from "services/redux/maintenance/pmTicket/action";
const mapStateToProps = (state) => ({
  pmAssigneeList: state.pmTicketReducer.pmAssigneeList,
  pmSlotDetails: state.pmTicketReducer.pmSlotDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmAssignee,
      postSchedulePM,
      fetchPmSlotDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ManagePMSlot);
